import { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';

import Calendar from './Calendar';
import { ArrowDownIconSmall }  from './Icons/ArrowIcons';

import useOnClickOutside from './hooks';

import './CalendarWithInput.css';

const CalendarWithInput = (props) => {
  const { label, disabled, dateRange, openCalendar=false, setOpenCalendar, isActiveDayDelivery } = props;

  const [ showCalendar, setShowCalendar ] = useState(false);

  useEffect(() => {
    setShowCalendar(openCalendar)
  },[openCalendar])

  const calendarRef = useRef();

  useOnClickOutside(calendarRef, () => {
    setShowCalendar(false)
    setOpenCalendar(false)
  });

  const handleClick = () => {
    setShowCalendar(!showCalendar)
  }

  const buttonClasses = cn('rntr-calendar-input__button', {
    'rntr-calendar-input__button_disabled': disabled
  });

  const date = disabled ? dateRange[1] : dateRange[0]
  const dateStr = dayjs(date).format('DD/MM/YYYY')
  return (
    <div className='rntr-calendar-input'>
      <div className='rntr-calendar-input__label'>{ label }</div>
      <button
        disabled={ disabled }
        className={ buttonClasses }
        type='button'
        onClick={ handleClick }>
        { dateStr }
        {
          !disabled &&
          <span className='rntr-calendar-input__icon'>
            <ArrowDownIconSmall fill='#000'/>
          </span>
        }
      </button>
      {
        showCalendar &&
        <Calendar {...props } calendarRef={calendarRef} />
      }
    </div>
  );
}

export default CalendarWithInput;
